import { useContent, useSite } from "../context/SiteContext";
import { ReviewCard } from "../components/site/Sections";
import { PageHero } from "./PublicLayout";

export default function ReviewsPage() {
  const c = useContent("reviews_section");
  const { site } = useSite();
  const reviews = site?.reviews || [];
  return (
    <div data-testid="reviews-page">
      <PageHero eyebrow={c.eyebrow} white={c.title_white} blue={c.title_blue} desc={c.description} />
      <div className="max-w-6xl mx-auto px-5 lg:px-8 py-16 columns-1 sm:columns-2 lg:columns-3 gap-5 [&>*]:mb-5 [&>*]:break-inside-avoid">
        {reviews.map((r) => <ReviewCard key={r.id} r={r} />)}
      </div>
      {reviews.length === 0 && <p className="text-center text-slate-400 pb-24" data-testid="reviews-page-empty">Reviews from our customers will appear here soon.</p>}
    </div>
  );
}
